const TOKEN = import.meta.env.VITE_DADATA_TOKEN as string;

export async function suggestCities(query: string): Promise<string[]> {
  if (!query.trim() || !TOKEN) return [];
  const res = await fetch('https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${TOKEN}`,
      'Accept': 'application/json',
    },
    body: JSON.stringify({
      query,
      from_bound: { value: 'city' },
      to_bound: { value: 'city' },
      locations: [{ country_iso_code: 'RU' }],
      count: 10,
    }),
  });
  const data = await res.json();
  return (data.suggestions ?? []).map((s: { value: string }) => s.value.replace(/^Россия,\s*/, ''));
}
